import script from "./EmbeddedForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbeddedForm.vue?vue&type=script&setup=true&lang=js"

import "./EmbeddedForm.vue?vue&type=style&index=0&id=28a39a3c&lang=css"

const __exports__ = script;

export default __exports__